var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "management-page-outer-container" },
    [
      _c("router-view"),
      _vm._v(" "),
      _vm.$route.name === "reservation-templates"
        ? _c(
            "reservation-templates-list",
            {
              attrs: { "search-from-parent": _vm.search },
              on: {
                "update-search": function($event) {
                  _vm.search = $event
                }
              }
            },
            [
              _c("management-add-button", {
                attrs: {
                  label: _vm.$t("AddTemplate"),
                  disabled: !_vm.userHasManagementPermission(
                    "asset_reservation_template",
                    "store"
                  ),
                  "list-missing-permissions": []
                },
                on: {
                  buttonClick: function($event) {
                    return _vm.$router.push({
                      name: "reservation-template-create"
                    })
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d1f7f6da", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d1f7f6da","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AssetReservationManagement/Templates/ReservationTemplates.vue
// module id = null
// module chunks = 